import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'
import {
  isDefined
} from "../../utils/utils";
import { refreshJwtToken } from "../../utils/mercurio.utils";
import ErrorModal from "./ErrorModal";
import IconTooltip from "./IconTooltip";



const EbayLinkActivator = ({
  originalJwtToken,
  user,
  eBay,
  renderEbayIcon,
  ebayUserLoginEndpoint,
  defaultEbayMarketplace,
  favoriteMarketplaceEndpoint,
  mercurioBaseUrl,
  handleOnClickActiveNowButton
}) => {

  const ebay = JSON.parse(eBay);
  const [sellerType, setSellerType] = useState('professional');
  const [favoriteMarketplace, setFavoriteMarketplace] = useState(null);
  const [hoverMarketplace, setHoverMarketplace] = useState(null);
  const [jwtToken, setJwtToken] = useState(originalJwtToken);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [openEbayLinkActivatorModal, setOpenEbayLinkActivatorModal] = useState(false);

  const MARKETPLACES_PAGINATOR = 8;


  // Funzione che gestisce il click sul bottone che avvia la procedura di attivazione dell'ebay link
  const handleClickOnEbayActivatorLinkBtn = () => {
    if (ebay) {
      if (ebay.marketplaces?.length > 1)
        setOpenEbayLinkActivatorModal(true);
      else
        window.location = ebayUserLoginEndpoint.replace(':ebay_domain', defaultEbayMarketplace);
    }
  }


  // Funzione che si occupa della chiusura della modale che permette all'utente di iniziare il processo di attivazione
  // del suo ebay link
  const handleCloseEbayLinkActivatorModal = () => {
    setOpenEbayLinkActivatorModal(false);
    if (isDefined(handleOnClickActiveNowButton))
      handleOnClickActiveNowButton()
    setFavoriteMarketplace(null);
  }


  // Funzione che comunica al server il marketplace di ebay scelto dall'utente come marketplace da lui preferito
  // su cui pubblicare i suoi futuri annunci di vendita
  const handleConfirmFavoriteMarketplace = (firstRun = false, token = null) => {
    if (isDefined(favoriteMarketplace)) {
      fetch(favoriteMarketplaceEndpoint + ".json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": token || jwtToken
        },
        body: JSON.stringify({
          user_email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          favorite_marketplace: favoriteMarketplace.name,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            if (response.redirected && response.status === 404 && response.url.includes("/users/sign_in")) {
              if (firstRun)
                refreshJwtToken(handleConfirmFavoriteMarketplace)
            } else
              throw Error("An error occour during getting user access_token from mercurio");
          }
          else
            return response.json();
        })
        .then((data) => {
          window.location = ebayUserLoginEndpoint.replace(':ebay_domain', favoriteMarketplace.meta_name);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          handleCloseEbayLinkActivatorModal();
          setShowErrorModal(true);
        });
    }
  }



  return <React.Fragment>
    {
      renderEbayIcon ?
        <button
          className="btn bg-intense-blue-imp d-flex align-items-center br-50px border-none w-92 m-auto py-0 pl-0 pr-5 text-weight-500 color-white"
          onClick={handleClickOnEbayActivatorLinkBtn}
        >
          <div className="bg-aig-gradient br-50perc p-2px sale_item_icon_container--extra-small d-flex flex-directions-column my-0 mr-2">
            <div className="position--relative bg-white br-50perc d-flex justify-content-center flex-fill align-items-center p-2">
              <img src={ebay.thumb_logo_url} alt="" width="32px"></img>
            </div>
          </div>

          {I18n.t('js.indexSaleItems.ebayLink.activateYour').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
        </button>
        :
        <button
          className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
          onClick={handleClickOnEbayActivatorLinkBtn}
        >
          {I18n.t('js.indexSaleItems.ebayLink.activateYour').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
        </button>
    }



    {/* Modale che spiega all'utente che deve scegliere il marketplace di eBay su cui intende loggarsi e
        pubblicare poi le sue inserzioni una volta attivato l'ebay link */}
    <Modal animation={false} centered size="lg"
      show={openEbayLinkActivatorModal}
      onHide={handleCloseEbayLinkActivatorModal}
    >
      <Modal.Body className="p-0">
        <div className="border-bottom-aiG-light-gray-imp px-2 pt-1 mx-3">
          <h4>{I18n.t('js.indexSaleItems.ebayLink.activateYour').replaceAll(':sale_channel', ebay.meta_name)}</h4>
        </div>

        <div className="d-block d-lg-flex justify-content-lg-around align-items-end text-center border-bottom-aiG-light-gray-imp px-3 mx-3">
          <div className={`text-center pt-3 pb-0 cursor-pointer ${sellerType === 'professional' ? 'text-aiBlue' : ''}`}
            onClick={() => setSellerType('professional')}
          >
            <b>{I18n.t(`js.indexSaleItems.ebayLink.marketplaceChoice.professional_seller.title`).replaceAll(':sale_channel', ebay.meta_name)}</b>
          </div>

          <div className="d-none d-lg-flex border-left-aiG-light-gray-imp" style={{ width: '1xp', height: '15px' }}></div>

          <div className={`text-center pt-3 pb-0 cursor-pointer ${sellerType === 'beginner' ? 'text-aiBlue' : ''}`}
            onClick={() => {
              setSellerType('beginner');
              setFavoriteMarketplace(null);
            }}
          >
            <b>{I18n.t(`js.indexSaleItems.ebayLink.marketplaceChoice.beginner_seller.title`).replaceAll(':sale_channel', ebay.meta_name)}</b>
          </div>
        </div>

        <div className="w-100 m-0 py-3 px-4">
          {
            sellerType === 'professional' ?
              <React.Fragment>
                {
                  [1, 2, 3].map(index => {
                    return <p key={`p_${index}`}>
                      {I18n.t(`js.indexSaleItems.ebayLink.marketplaceChoice.${sellerType}_seller.p_${index}`).replaceAll(':sale_channel', ebay.meta_name)}
                    </p>
                  })
                }

                <div className="d-flex flex-wrap justify-content-center align-items-center my-4 px-0 px-lg-5">
                  {
                    ebay.marketplaces.slice(0, MARKETPLACES_PAGINATOR).map((marketplace) => {
                      return <div className="d-block text-center my-2 mx-2 mx-md-3 mx-lg-4" key={marketplace.name}>
                        <div
                          className={`bg-${marketplace.available ? 'aig-gradient cursor-pointer' : 'gray'} br-50perc p-2px sale_item_icon_container--small d-flex flex-directions-column my-2`}
                          onMouseOver={() => marketplace.available ? setHoverMarketplace(marketplace) : {}}
                          onMouseOut={() => marketplace.available ? setHoverMarketplace(null) : {}}
                          onClick={() => marketplace.available ? setFavoriteMarketplace(marketplace) : {}}
                        >
                          <div
                            className={`position--relative ${hoverMarketplace?.name === marketplace.name || favoriteMarketplace?.name === marketplace.name ? '' : 'bg-white'} br-50perc d-flex justify-content-center flex-fill align-items-center p-2`}>
                            <img src={`${mercurioBaseUrl}/${marketplace.icon_url}`} width="45px"
                              className={!marketplace.available ? 'opacity-0_4' : ''} />
                          </div>
                        </div>

                        <div
                          className={`mt-3 ${hoverMarketplace?.name === marketplace.name || favoriteMarketplace?.name === marketplace.name ? 'text-aiBlue' : ''}`}>
                          {marketplace.meta_name ? marketplace.meta_name : (marketplace.web_site_url ? marketplace.web_site_url : marketplace.name)}
                        </div>
                      </div>
                    }
                    )
                  }

                  {
                    ebay.marketplaces?.length > MARKETPLACES_PAGINATOR &&
                    <div className="m-3">
                      <p className="mb-1">
                        {I18n.t('js.indexSaleItems.ebayLink.marketplaceChoice.more_marketplaces.label').replaceAll(':sale_channel', ebay.meta_name)}
                      </p>

                      <select
                        className="form-control"
                        value={favoriteMarketplace?.name ? favoriteMarketplace.name : ''}
                        name="marketplace_selector"
                        id="marketplace_selector"
                        onChange={(e) => {
                          let selectedMarketplace = null;
                          if (e.target.value)
                            selectedMarketplace = ebay.marketplaces.slice(MARKETPLACES_PAGINATOR).filter(marketplace => marketplace.name === e.target.value)[0];
                          setFavoriteMarketplace(selectedMarketplace);
                        }}
                      >
                        <option value="">
                          {I18n.t('js.indexSaleItems.ebayLink.marketplaceChoice.more_marketplaces.placeholder').replaceAll(':sale_channel', ebay.meta_name)}
                        </option>
                        {ebay.marketplaces.slice(MARKETPLACES_PAGINATOR).map((marketplace) => (
                          <option value={marketplace.name} key={marketplace.name} disabled={!marketplace.available}>
                            {marketplace.meta_name ? marketplace.meta_name : (marketplace.web_site_url ? marketplace.web_site_url : marketplace.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                  }
                </div>

                <div>
                  <p>
                    {
                      [4, 5, 6].map(index => {
                        return <span key={`p_${index}`} className={`${index === 5 ? 'text-aiBlue' : ''}`}>
                          {I18n.t(`js.indexSaleItems.ebayLink.marketplaceChoice.${sellerType}_seller.p_${index}`).replaceAll(':sale_channel_marketplace', favoriteMarketplace ? favoriteMarketplace.meta_name : ebay.meta_name).replaceAll(':sale_channel', ebay.meta_name)}
                        </span>
                      })
                    }
                  </p>
                </div>
              </React.Fragment>
              :
              <React.Fragment>
                {
                  [1, 2, 3, 4, 5].map(index => {
                    return <p key={`p_${index}`}>
                      {I18n.t(`js.indexSaleItems.ebayLink.marketplaceChoice.${sellerType}_seller.p_${index}`).replaceAll(':sale_channel', ebay.meta_name)}
                    </p>
                  })
                }
              </React.Fragment>
          }

          <div className="d-flex justify-content-between w-100 mx-0 mt-4">
            <div>
              <button
                type="button"
                className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                onClick={handleCloseEbayLinkActivatorModal}
              >
                {I18n.t('js.common.cancel').toUpperCase()}
              </button>
            </div>

            <div>
              {
                (favoriteMarketplace || sellerType !== 'professional') ?
                  <button className={`btn ${sellerType !== 'professional' ? 'btn-secondary' : 'bg-intense-blue-imp'} br-50px border-none m-auto px-4 text-weight-500 color-white`}
                    onClick={handleConfirmFavoriteMarketplace}
                    disabled={sellerType !== 'professional'}
                  >
                    {I18n.t('js.common.confirm').toUpperCase()}
                  </button>
                  :
                  <IconTooltip
                    tooltipContent={I18n.t('js.indexSaleItems.ebayLink.marketplaceChoice.more_marketplaces.placeholder').replaceAll(':sale_channel', ebay.meta_name)}
                    tooltipPosition={'bottom'}
                    customComponentToRender={
                      <React.Fragment>
                        <button
                          className="btn btn-secondary br-50px border-none m-auto px-4 text-weight-500 color-white"
                          disabled={true}
                          onClick={() => {
                          }}
                        >
                          {I18n.t('js.common.confirm').toUpperCase()}
                        </button>
                      </React.Fragment>
                    }
                  />
              }
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>




    <ErrorModal
      showErrorModal={showErrorModal}
      setShowErrorModal={setShowErrorModal}
    />
  </React.Fragment>
};

export default EbayLinkActivator;